import * as React from "react";
import { makeStyles, Caption1, Title3, Body1Strong } from "@fluentui/react-components";
import { OrganizationSelectList } from "../common";
import { envUtils } from "../../../utils/envUtils";

const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    overflowY: "auto",
  },
  content: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    padding: "0 15px",
  },
});

export const Settings = () => {
  const styles = useStyles();

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <Title3>Settings</Title3>
        <Caption1>
          The organization selected below will be used as the default organization when creating new
          meetings using this add-in. You can change the default organization ad any time by going
          to this add-ins settings.
        </Caption1>
      </div>

      <OrganizationSelectList />
    </div>
  );
};
